import { Page } from '@/components/layout/page/page.tsx'

export const TaskPageSkeleton = () => {
  return (
    <Page
      title="Tasks"
      headerOptions={
        <div className="grid grid-cols-12 gap-[16px] w-[250px] lg:w-[500px] mb-4">
          <div className="col-span-12 lg:col-span-6 bg-skeleton animate-pulse rounded-lg h-[40px]">
            &nbsp;
          </div>
          <div className="col-span-6 lg:col-span-3 bg-skeleton animate-pulse rounded-lg h-[40px]">
            &nbsp;
          </div>
          <div className="col-span-6 lg:col-span-3 bg-skeleton animate-pulse rounded-lg h-[40px]">
            &nbsp;
          </div>
        </div>
      }
    >
      <div className="p-1 rounded-lg border grid grid-flow-row grid-cols-2 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6  gap-[4px] items-center w-full">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="w-full h-[32px] px-[12px] gap-[8px] rounded-md bg-skeleton animate-pulse"
          >
            &nbsp;
          </div>
        ))}
      </div>
      <div className="mt-6 bg-skeleton animate-pulse w-full h-[200px] rounded-lg mb-2" />
      <div className="mt-6 bg-skeleton animate-pulse rounded-lg h-[40px] w-[120px]">
        &nbsp;
      </div>
      <div className="mt-4 bg-skeleton animate-pulse w-full h-[200px] rounded-lg mb-2" />
    </Page>
  )
}
